<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { ddlHelper, sessionHelper } from "@/utils";
import { SESSION, MODULE } from "@/constants";
import { required } from "vuelidate/lib/validators";
import { mapState } from "vuex";
import i18n from "@/i18n";
import { AI_MODULE } from '@/state/modules/activeIngredient'
import { BRAND_MODULE } from '@/state/modules/brand'
import { CATEGORY_MODULE } from '@/state/modules/category'
import { CLASS_MODULE } from '@/state/modules/class'
import { FORM_MODULE } from '@/state/modules/form'
import { MOA_MODULE } from '@/state/modules/moa'
import { PRINTER_PFOOF_MODULE } from '@/state/modules/printerProofStatus'
import { PURPOSE_MODULE } from '@/state/modules/purpose'
import { QUERY_STATUS_MODULE } from '@/state/modules/queryStatus'
import { REGISTRATION_STATUS_MODULE } from '@/state/modules/registrationStatus'
import { RISK_STATUS_MODULE } from '@/state/modules/riskStatus'
import { SOURCE_MODULE } from '@/state/modules/source'
import { STATUS_MODULE } from '@/state/modules/status'
import { TYPE_MODULE } from '@/state/modules/type'
import { aiMethods, brandMethods, categoryMethods, classMethods, formMethods, moaMthods, printerProofMethods, purposeMethods, queryStatusMethods, registrationStatusMethods, riskStatusMethods, sourceMethods, statusMethods, typeMethods } from "@/state/helpers";
import Swal from "sweetalert2";

export default {
  page: {
    title: i18n.t("label.createX", []),
  },
  components: { Layout, PageHeader },
  beforeRouteLeave(to, from, next) {
    if (this.$route.query.module == MODULE.AI && to.name != "AI-listing") {
      sessionHelper.clearSearch(SESSION.ACTIVE_INGREDIENT_SEARCH);
    }
    else if (this.$route.query.module == MODULE.BRAND && to.name != "Brand-listing") {
      sessionHelper.clearSearch(SESSION.BRAND_SEARCH);
    }
    else if (this.$route.query.module == MODULE.CATEGORY && to.name != "Category-listing") {
      sessionHelper.clearSearch(SESSION.CATEGORY_SEARCH);
    }
    else if (this.$route.query.module == MODULE.CLASS && to.name != "Class-listing") {
      sessionHelper.clearSearch(SESSION.CLASS_SEARCH);
    }
    else if (this.$route.query.module == MODULE.FORM && to.name != "Form-listing") {
      sessionHelper.clearSearch(SESSION.FORM_SEARCH);
    }
    else if (this.$route.query.module == MODULE.MOA && to.name != "MOA-listing") {
      sessionHelper.clearSearch(SESSION.MOA_SEARCH);
    }
    else if (this.$route.query.module == MODULE.PRINTER_PROOF && to.name != "Printer-proof-listing") {
      sessionHelper.clearSearch(SESSION.MOA_SEARCH);
    }
    else if (this.$route.query.module == MODULE.PURPOSE && to.name != "Purpose-listing") {
      sessionHelper.clearSearch(SESSION.PURPOSE_SEARCH);
    }
    else if (this.$route.query.module == MODULE.QUERY_STATUS && to.name != "Query-status-listing") {
      sessionHelper.clearSearch(SESSION.QUERY_STATUS_SEARCH);
    }
    else if (this.$route.query.module == MODULE.REGISTARTION_STATUS && to.name != "Registration-status-listing") {
      sessionHelper.clearSearch(SESSION.REGISTRATION_STATUS_SEARCH);
    }
    else if (this.$route.query.module == MODULE.RISK_STATUS && to.name != "Risk-status-listing") {
      sessionHelper.clearSearch(SESSION.RISK_STATUS_SEARCH);
    }
    else if (this.$route.query.module == MODULE.SOURCE && to.name != "Source-listing") {
      sessionHelper.clearSearch(SESSION.SOURCE_SEARCH);
    }
    else if (this.$route.query.module == MODULE.STATUS && to.name != "Status-listing") {
      sessionHelper.clearSearch(SESSION.STATUS_SEARCH);
    }
    else if (this.$route.query.module == MODULE.TYPE && to.name != "Type-listing") {
      sessionHelper.clearSearch(SESSION.TYPE_SEARCH);
    }
    next();
  },
  computed: {
    ...mapState(AI_MODULE, ["status"]),
    ...mapState(BRAND_MODULE, ["status"]),
    ...mapState(CATEGORY_MODULE, ["status"]),
    ...mapState(CLASS_MODULE, ["status"]),
    ...mapState(FORM_MODULE, ["status"]),
    ...mapState(MOA_MODULE, ["status"]),
    ...mapState(PRINTER_PFOOF_MODULE, ["status"]),
    ...mapState(PURPOSE_MODULE, ["status"]),
    ...mapState(QUERY_STATUS_MODULE, ["status"]),
    ...mapState(REGISTRATION_STATUS_MODULE, ["status"]),
    ...mapState(RISK_STATUS_MODULE, ["status"]),
    ...mapState(SOURCE_MODULE, ["status"]),
    ...mapState(STATUS_MODULE, ["status"]),
    ...mapState(TYPE_MODULE, ["status"]),
    titleData() {
      return this.titleText;
    },
    itemData() {
      return this.items;
    },
  },
  data() {
    return {
      titleText: '',
      title: this.titleText,
      items: [],
      permissions: sessionHelper.getPermissions(),
      createPermission: null,
      submitted: false,
      statusDdl: ddlHelper.getActivationStatus(false, true),
      createForm: {
        name: "",
      },
    };
  },
  validations: {
    createForm: {
      name: { required },
    },
  },
  created() {
    var jsonPermissions = JSON.parse(this.permissions)

    if (this.$route.query.module == MODULE.AI) {
      this.titleText = i18n.t("label.createX", [i18n.t("module.activeIngredient")])
      this.items = [
        {
          text: i18n.t("module.dashboard"),
          href: "/",
        },
        {
          text: i18n.t("module.activeIngredient"),
          href: "/AI",
        },
        {
          text: i18n.t("label.createX", [i18n.t("module.activeIngredient")]),
          active: true,
        },
      ]

      if (jsonPermissions.some(p => p.code === "RND_AI_AIC")) {
        this.createPermission = true;
      }
      else {
        this.createPermission = false;
      }
    }
    else if (this.$route.query.module == MODULE.BRAND) {
      this.titleText = i18n.t("label.createX", [i18n.t("module.brand")])
      this.items = [
        {
          text: i18n.t("module.dashboard"),
          href: "/",
        },
        {
          text: i18n.t("module.brand"),
          href: "/brand",
        },
        {
          text: i18n.t("label.createX", [i18n.t("module.brand")]),
          active: true,
        },
      ]

      if (jsonPermissions.some(p => p.code === "RND_BRAND_BC")) {
        this.createPermission = true;
      }
      else {
        this.createPermission = false;
      }
    }
    else if (this.$route.query.module == MODULE.CATEGORY) {
      this.titleText = i18n.t("label.createX", [i18n.t("module.category")])
      this.items = [
        {
          text: i18n.t("module.dashboard"),
          href: "/",
        },
        {
          text: i18n.t("module.category"),
          href: "/category",
        },
        {
          text: i18n.t("label.createX", [i18n.t("module.category")]),
          active: true,
        },
      ]

      if (jsonPermissions.some(p => p.code === "RND_CATEGORY_CC")) {
        this.createPermission = true;
      }
      else {
        this.createPermission = false;
      }
    }
    else if (this.$route.query.module == MODULE.CLASS) {
      this.titleText = i18n.t("label.createX", [i18n.t("module.class")])
      this.items = [
        {
          text: i18n.t("module.dashboard"),
          href: "/",
        },
        {
          text: i18n.t("module.class"),
          href: "/class",
        },
        {
          text: i18n.t("label.createX", [i18n.t("module.class")]),
          active: true,
        },
      ]

      if (jsonPermissions.some(p => p.code === "RND_CLASS_CLSC")) {
        this.createPermission = true;
      }
      else {
        this.createPermission = false;
      }
    }
    else if (this.$route.query.module == MODULE.FORM) {
      this.titleText = i18n.t("label.createX", [i18n.t("module.form")])
      this.items = [
        {
          text: i18n.t("module.dashboard"),
          href: "/",
        },
        {
          text: i18n.t("module.form"),
          href: "/form",
        },
        {
          text: i18n.t("label.createX", [i18n.t("module.form")]),
          active: true,
        },
      ]

      if (jsonPermissions.some(p => p.code === "RND_FORM_FC")) {
        this.createPermission = true;
      }
      else {
        this.createPermission = false;
      }
    }
    else if (this.$route.query.module == MODULE.MOA) {
      this.titleText = i18n.t("label.createX", [i18n.t("module.moa")])
      this.items = [
        {
          text: i18n.t("module.dashboard"),
          href: "/",
        },
        {
          text: i18n.t("module.moa"),
          href: "/moa",
        },
        {
          text: i18n.t("label.createX", [i18n.t("module.moa")]),
          active: true,
        },
      ]

      if (jsonPermissions.some(p => p.code === "RND_MOA_MOAC")) {
        this.createPermission = true;
      }
      else {
        this.createPermission = false;
      }
    }
    else if (this.$route.query.module == MODULE.PRINTER_PROOF) {
      this.titleText = i18n.t("label.createX", [i18n.t("module.printerProof")])
      this.items = [
        {
          text: i18n.t("module.dashboard"),
          href: "/",
        },
        {
          text: i18n.t("module.printerProof"),
          href: "/printer-proof",
        },
        {
          text: i18n.t("label.createX", [i18n.t("module.printerProof")]),
          active: true,
        },
      ]

      if (jsonPermissions.some(p => p.code === "RND_PP_PPC")) {
        this.createPermission = true;
      }
      else {
        this.createPermission = false;
      }
    }
    else if (this.$route.query.module == MODULE.PURPOSE) {
      this.titleText = i18n.t("label.createX", [i18n.t("module.purpose")])
      this.items = [
        {
          text: i18n.t("module.dashboard"),
          href: "/",
        },
        {
          text: i18n.t("module.purpose"),
          href: "/purpose",
        },
        {
          text: i18n.t("label.createX", [i18n.t("module.purpose")]),
          active: true,
        },
      ]

      if (jsonPermissions.some(p => p.code === "RND_PURPOSE_PC")) {
        this.createPermission = true;
      }
      else {
        this.createPermission = false;
      }
    }
    else if (this.$route.query.module == MODULE.QUERY_STATUS) {
      this.titleText = i18n.t("label.createX", [i18n.t("module.queryStatus")])
      this.items = [
        {
          text: i18n.t("module.dashboard"),
          href: "/",
        },
        {
          text: i18n.t("module.queryStatus"),
          href: "/query-status",
        },
        {
          text: i18n.t("label.createX", [i18n.t("module.queryStatus")]),
          active: true,
        },
      ]

      if (jsonPermissions.some(p => p.code === "RND_QSTATUS_QSC")) {
        this.createPermission = true;
      }
      else {
        this.createPermission = false;
      }
    }
    else if (this.$route.query.module == MODULE.REGISTARTION_STATUS) {
      this.titleText = i18n.t("label.createX", [i18n.t("module.registrationStatus")])
      this.items = [
        {
          text: i18n.t("module.dashboard"),
          href: "/",
        },
        {
          text: i18n.t("module.registrationStatus"),
          href: "/registration-status",
        },
        {
          text: i18n.t("label.createX", [i18n.t("module.registrationStatus")]),
          active: true,
        },
      ]

      if (jsonPermissions.some(p => p.code === "RND_RSTSTATUS_RSTSC")) {
        this.createPermission = true;
      }
      else {
        this.createPermission = false;
      }
    }
    else if (this.$route.query.module == MODULE.RISK_STATUS) {
      this.titleText = i18n.t("label.createX", [i18n.t("module.riskStatus")])
      this.items = [
        {
          text: i18n.t("module.dashboard"),
          href: "/",
        },
        {
          text: i18n.t("module.riskStatus"),
          href: "/risk-status",
        },
        {
          text: i18n.t("label.createX", [i18n.t("module.riskStatus")]),
          active: true,
        },
      ]

      if (jsonPermissions.some(p => p.code === "RND_RS_RSC")) {
        this.createPermission = true;
      }
      else {
        this.createPermission = false;
      }
    }
    else if (this.$route.query.module == MODULE.SOURCE) {
      this.titleText = i18n.t("label.createX", [i18n.t("module.source")])
      this.items = [
        {
          text: i18n.t("module.dashboard"),
          href: "/",
        },
        {
          text: i18n.t("module.source"),
          href: "/source",
        },
        {
          text: i18n.t("label.createX", [i18n.t("module.source")]),
          active: true,
        },
      ]

      if (jsonPermissions.some(p => p.code === "RND_SOURCE_SC")) {
        this.createPermission = true;
      }
      else {
        this.createPermission = false;
      }
    }
    else if (this.$route.query.module == MODULE.STATUS) {
      this.titleText = i18n.t("label.createX", [i18n.t("module.status")])
      this.items = [
        {
          text: i18n.t("module.dashboard"),
          href: "/",
        },
        {
          text: i18n.t("module.status"),
          href: "/status",
        },
        {
          text: i18n.t("label.createX", [i18n.t("module.status")]),
          active: true,
        },
      ]

      if (jsonPermissions.some(p => p.code === "RND_STATUS_SC")) {
        this.createPermission = true;
      }
      else {
        this.createPermission = false;
      }
    }
    else if (this.$route.query.module == MODULE.TYPE) {
      this.titleText = i18n.t("label.createX", [i18n.t("module.type")])
      this.items = [
        {
          text: i18n.t("module.dashboard"),
          href: "/",
        },
        {
          text: i18n.t("module.type"),
          href: "/type",
        },
        {
          text: i18n.t("label.createX", [i18n.t("module.type")]),
          active: true,
        },
      ]

      if (jsonPermissions.some(p => p.code === "RND_TYPE_TC")) {
        this.createPermission = true;
      }
      else {
        this.createPermission = false;
      }
    }
    else {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false
      });

      swalWithBootstrapButtons
        .fire({
          title: i18n.t('message.invalidX', [i18n.t('label.moduleX', [])]),
          text: i18n.t('message.invalidDataPleaseContactAdmin'),
          icon: "error",
          confirmButtonText: "OK",
        })
        .then(result => {
          if (result.value) {
            this.$router.go(-1);
          }
        });
    }
  },
  methods: {
    ...aiMethods,
    ...brandMethods,
    ...categoryMethods,
    ...classMethods,
    ...formMethods,
    ...moaMthods,
    ...printerProofMethods,
    ...purposeMethods,
    ...queryStatusMethods,
    ...registrationStatusMethods,
    ...riskStatusMethods,
    ...sourceMethods,
    ...statusMethods,
    ...typeMethods,
    requestCreate() {
      this.submitted = true;
      // stop here if form is invalid
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      } else {
        let data = {
          name: this.createForm.name,
        };

        if (this.createPermission == true) {
          if (this.$route.query.module == MODULE.AI) {
            this.createAI({ data });
          }
          else if (this.$route.query.module == MODULE.BRAND) {
            this.createBrand({ data });
          }
          else if (this.$route.query.module == MODULE.CATEGORY) {
            this.createCategory({ data });
          }
          else if (this.$route.query.module == MODULE.CLASS) {
            this.createClass({ data });
          }
          else if (this.$route.query.module == MODULE.FORM) {
            this.createFormData({ data });
          }
          else if (this.$route.query.module == MODULE.MOA) {
            this.createMOA({ data });
          }
          else if (this.$route.query.module == MODULE.PRINTER_PROOF) {
            this.createPrinterProof({ data });
          }
          else if (this.$route.query.module == MODULE.PURPOSE) {
            this.createPurpose({ data });
          }
          else if (this.$route.query.module == MODULE.QUERY_STATUS) {
            this.createQuery({ data });
          }
          else if (this.$route.query.module == MODULE.REGISTARTION_STATUS) {
            this.createRegistration({ data });
          }
          else if (this.$route.query.module == MODULE.RISK_STATUS) {
            this.createRisk({ data });
          }
          else if (this.$route.query.module == MODULE.SOURCE) {
            this.createSource({ data });
          }
          else if (this.$route.query.module == MODULE.STATUS) {
            this.createStatus({ data });
          }
          else if (this.$route.query.module == MODULE.TYPE) {
            this.createType({ data });
          }
        }
      }
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="titleData" :items="itemData" />
    <div class="row">
      <div class="col">
        <div class="card">
          <div class="card-body">
            <form @submit.prevent="requestCreate" v-if="this.createPermission == true">
              <b-form-group id="name" label-cols-sm="2" label-cols-lg="2" :label="$t('label.name')" label-for="name">
                <b-form-input for="name" v-model.trim="createForm.name" :class="{
                  'is-invalid': submitted &&
                    !$v.createForm.name.required
                }"></b-form-input>
                <div v-if="submitted &&
                  !$v.createForm.name.required" class="invalid-feedback">
                  <span v-if="!$v.createForm.name.required">{{
                    $t("message.requiredX", [$t("label.name")])
                  }}</span>
                </div>
              </b-form-group>

              <div class="mt-4 text-center" style="float: right">
                <button class="btn btn-primary w-md waves-effect waves-light" style="margin-right: 10px" type="submit"
                  :disabled="status.status">
                  {{ this.titleData }}
                </button>
              </div>
            </form>
            <div style="text-align: center;" v-else>
              {{ $t('message.noPermissionMessage') }}
            </div>
          </div>
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
  </Layout>
</template>